import './Footer.scss';
function Footer() {
  return (
    <footer className="footer-container">
      {/*footer header*/}
      <div className="footer-header">
        <div>
          <span>Get connected with me on social networks!</span>
        </div>
        {/* social icons container */}
        <div className="social-icons-container">
          <a className="social-icons" href="https://www.instagram.com/lorenzoviganego/?igsh=eHhoMWpqZXozN3B2#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className=""
              fill="white"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              >      
              <path d="M12 2.163c3.204.0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849.0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204.0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849.0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741.0 8.333.014 7.053.072c-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24s3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403.0-6.162 2.759-6.162 6.162S8.597 18.163 12 18.163s6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zM12 16c-2.209.0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796.0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795.0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path>
            </svg>
          </a>
          <a className="social-icons" href="https://www.linkedin.com/in/lorenzo-viganego-1325441a3/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className=""
              fill="white"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              >      
              <path d="M4.98 3.5C4.98 4.881 3.87 6 2.5 6s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zM5 8H0v16h5V8zm7.982.0H8.014v16h4.969v-8.399c0-4.67 6.029-5.052 6.029.0V24H24V13.869c0-7.88-8.922-7.593-11.018-3.714V8z"></path>
            </svg>
          </a>
          <a className="social-icons" href="https://github.com/lorenzoVwebDev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className=""
              fill="white"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              >      
              <path d="M12 0C5.374.0.0 5.373.0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931.0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176.0.0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221.0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"></path>
            </svg>
          </a>
        </div>
      </div>
      {/*main footer section*/}
      <div className="main-footer-section">
        <div className="main-footer-section-grid">
          {/*left part*/}
          <div className="main-footer-section-left">
            <h6>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-4 w-4"
                width="24"
                height="24"
            >
                <path
                  d="M12.378 1.602a.75.75 0 00-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03zM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 00.372-.648V7.93zM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 00.372.648l8.628 5.033z" />
              </svg>
              Abstract
            </h6>
            <p>
              A Project that involves the usage of the redux-library in React. Very useful to manage both states and states' reducers.
            </p>
          </div>
          {/*central part*/}
          <div className="main-footer-section-central-left">
            <h6>
              Libraries/Frameworks
            </h6>
            <p>
              <a href="https://react.dev/">React</a>
            </p>
            <p>
              <a href="https://redux.dev/">Redux</a>
            </p>
            <p>
              <a href="https://sass-lang.com/">Sass</a>
            </p>
          </div>
          <div className="main-footer-section-central-right">
            <h6>
              Other React Repositories
            </h6>
            <p>
              <a href="https://github.com/lorenzoVwebDev/loginPage">Login Page</a>
            </p>
            <p>
              <a href="https://github.com/lorenzoVwebDev/salad-maker-repository">Salad Maker</a>
            </p>
            <p>
              <a href="https://github.com/lorenzoVwebDev/text-analyzer">Text Analyzer</a>
            </p>
          </div>
          {/*right part*/}
          <div className="main-footer-section-right">
            <h6>
              Contacts
            </h6>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
                width="24"
                heigth="24"
                >
                <path
                  d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                <path
                  d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
              </svg>
              Rome, Italy
            </p>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
                width="24"
                heigth="24"
                >
                <path
                  d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                <path
                  d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
              </svg>
              lorenzoviganego.work@libero.it
            </p>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
                width="24"
                heigth="24"
                >
                <path
                  fillRule="evenodd"
                  d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                  clipRule="evenodd" />
              </svg>
              +39 351 743 1574
            </p>
          </div>
          </div> 
      </div>
      {/*low footer section*/}
      <div className="low-footer-section">
        <span>Copyright © 2024</span>
        <a href="https://www.lorenzo-viganego.com/">Copyright © 2024 by Lorenzo Viganego || All Rights Reserved.</a>
      </div>
    </footer>
  )
}

export default Footer;